<template>
    <InformeCard
        @click="draw"
        title="Categorías de los Dispositivos"
        v-if="categoriasDispositivos"
        id="categorias-del-dispositivo"
        name="categorias-del-dispositivo"
        collapsable="true"
    >
        <h4 class="text-center">Categorías de los Dispositivos</h4>
        <GChart
            type="PieChart"
            :data="categoriasDispositivos"
            :options="chartOptions"
            ref="googleChart"
        />
    </InformeCard>
</template>

<script>
    import InformeCard from "../InformeCard";

    export default {
        props: ["event_id"],
        data() {
            return {
                categoriasDispositivos: [],
                chartOptions: {
                    height: 364,
                    chartArea: { width: "100%" },
                    pieHole: 0.4,
                    sliceVisibilityThreshold: 0,
                },
            };
        },
        methods: {
            getCategoriasDispositivos() {
                const params = {
                    filters: {},
                    evento_id: this.event_id,
                };
                this.$store
                    .dispatch(
                        this.config.getVuexAlias("back.events.informe.categorias-dispositivos"),
                        params
                    )
                    .then(res => {
                        this.categoriasDispositivos = res.data;
                    });
            },
            draw() {
                setTimeout(() => {
                    this.$refs.googleChart.drawChart();
                }, 50);
            },
        },
        created() {
            this.getCategoriasDispositivos();
        },
        components: {
            InformeCard,
        },
    };
</script>
